/**
 * @Description: 订阅消息
 * @author Shi_qshan
 * @date 2022/8/29
*/
import React from "react";
import {Route} from "react-router-dom";
import loadable from "../../loadable"
import QwHeader from "../../layout/header";

const SubscribeMsg = loadable(() => import('./subscribeMsg'));

class SubscribeRoute extends React.Component {

    render() {
        return (
            <>
                {/*订阅消息*/}
                <Route path={this.props.match.url + "/subscribe-msg"} component={SubscribeMsg}/>
            </>
        )
    }
}

export default SubscribeRoute